namespace Matrix.Dashboards {
    export interface DashboardData {
        Description?: string;
        ParamBindingsOnToolbar?: string[];
        NavigationPath?: string;
        NavigationOrder?: number;
        NavigationPermission?: string;
        Items?: DashboardItem[];
    }
}
